// @flow
import { connect } from "react-redux";

import MapView from "./view";
import { fetchStops } from "../state/map/actions";

export default connect(
    state => ({
        stops: state.map.all,
        userInfo: state.context.userInfo
    }),
    dispatch => ({
        onFetchStops: () => dispatch(fetchStops())
    })
)(MapView);



// WEBPACK FOOTER //
// ./src/map/index.js